export default "__VITE_ASSET__DqmaFJbr__"